
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Beispiel-Userdaten mit PINs und Bildern

const USERS = [
  { name: "Rasmus", pin: "1111", img: "/assets/Logo.png" },
  { name: "Silas", pin: "2222", img: "/assets/logo1.png" },
  { name: "Jokim", pin: "3333", img: "/assets/logo2.png" },
  { name: "Talika", pin: "2002", img: "/assets/logo3.png" },
  { name: "Caroline", pin: "1571", img: "/assets/logo4.png" },
  { name: "Katja", pin: "1234", img: "/assets/logo5.png" },
  { name: "Janika", pin: "2002", img: "/assets/logo6.png" },
  { name: "Kiara", pin: "8888", img: "/assets/logo7.png" },
  { name: "Max", pin: "9999", img: "/assets/logo8.png" },
  { name: "Culbin", pin: "1010", img: "/assets/logo9.png" },
  { name: "Lena", pin: "1212", img: "/assets/logo10.png" },
  { name: "Stefan", pin: "1313", img: "/assets/logo11.png" }
];

function Loinport() {
  const [pins, setPins] = useState({});
  const [errorMessages, setErrorMessages] = useState({});
  const navigate = useNavigate();

  const handlePinChange = (name, value) => {
    setPins(p => ({ ...p, [name]: value }));
  };

  const handleLogin = (user) => {
    // Fehler für diesen Benutzer zurücksetzen
    setErrorMessages(prev => ({ ...prev, [user.name]: "" }));

    if (!pins[user.name]) {
      setErrorMessages(prev => ({ ...prev, [user.name]: "Bitte PIN eingeben" }));
      return;
    }

    if (pins[user.name] === user.pin) {
      sessionStorage.setItem("username", user.name);
      navigate("/dasboart");
    } else {
      setErrorMessages(prev => ({ ...prev, [user.name]: "Falsche PIN" }));
    }
  };

  return (
      <React.Fragment>
    
    <div className="loinportbord">
      {USERS.map(user => (
        <div className="loginprtperson" key={user.name}>
          <div className="imegeprvider">
            <img src={user.img} alt={user.name} />
          </div>
          <h6 className="usersowname">{user.name}</h6>
          <form onSubmit={e => { e.preventDefault(); handleLogin(user); }}>
          <input
            type="password"
            className="inpuntpin"
            value={pins[user.name] || ""}
            onChange={e => handlePinChange(user.name, e.target.value)}
            placeholder="PIN eingeben"
          />
          </form>
          <button className="loginpin" onClick={() => handleLogin(user)}>Login</button>
          {errorMessages[user.name] && (
            <div style={{
              color: 'red',
              fontSize: '12px',
              marginTop: '5px',
              padding: '5px',
              backgroundColor: '#ffebee',
              borderRadius: '4px'
            }}>
              {errorMessages[user.name]}
            </div>
          )}
        </div>
      ))}
    </div>
    </React.Fragment>      
  );
}

export default Loinport;